module.exports = __webpack_public_path__ + "static/img/00319v.9c22a46.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00319v.jpg
// module id = bfmo
// module chunks = 1